module.exports = __webpack_public_path__ + "static/media/whats_Happening_Philly_2.eca453f2.jpg";